import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { fromUserRoleList } from '../reducers';
import { authSelectors } from '@content-platform/web-angular-shared-util-auth';

import { Permission, UserRoleList } from '../models';
import { Dictionary } from '@ngrx/entity';

export const getUserRoleListRootState: MemoizedSelector<
unknown,
fromUserRoleList.State
> = createFeatureSelector<fromUserRoleList.State>('userRoleList');
export const getUserRoleListState: MemoizedSelector<
unknown,
fromUserRoleList.State
> = createSelector(getUserRoleListRootState, (state) => state);

const userRoleListSelectors = fromUserRoleList.userRoleListAdapter.getSelectors(
  getUserRoleListState
);
export const getAllUserRoleListItems: (state: unknown) => UserRoleList[] =
  userRoleListSelectors.selectAll;
export const getUserRoleListEntities: (state: unknown) => Dictionary<UserRoleList> =
  userRoleListSelectors.selectEntities;

/**
 * Selector to return the loaded property of the state
 */
export const getUserRoleListLoaded: MemoizedSelector<unknown, boolean> = createSelector(
  getUserRoleListState,
  fromUserRoleList.getUserRoleListLoaded
);
export const getUserRoleListLoading: MemoizedSelector<unknown, boolean> = createSelector(
  getUserRoleListState,
  fromUserRoleList.getUserRoleListLoading
);

export const getActiveUserRoleList: MemoizedSelector<
unknown,
UserRoleList | undefined
> = createSelector(
  getUserRoleListEntities,
  authSelectors.getUserId,
  (userRoleListEntities, userId) => userRoleListEntities[userId]
);

/**
 *  Gets an array of the names of the roles this user was assigned
 */
export const getActiveUserRoleNames: MemoizedSelector<
unknown,
string[]
> = createSelector(getActiveUserRoleList, (roleList) =>
  (roleList ? roleList.roles : []).map((role) => role.name).sort((a, b) => a.localeCompare(b))
);

/**
 * Selector to get current user permissions
 */
export const getUserPermissions: MemoizedSelector<
unknown,
undefined | Permission[]
> = createSelector(getActiveUserRoleList, (userRoleList: UserRoleList) => {
  if (!userRoleList || !userRoleList.roles) {
    return undefined;
  }
  return userRoleList.roles
    .map((role) => role.permissions)
    .reduce(
      (listSoFar, currentPermissions) =>
        listSoFar.concat(
          currentPermissions.filter(
            (currentPermission) =>
              !listSoFar
                .map((existingPermission) => existingPermission.id)
                .includes(currentPermission.id)
          )
        ),
      []
    );
});
